import { IControlledAirspaceAdvisoryProperties, MissionFeatureCollection } from '@autopylot-internal/tiles-client';
import { LAANCInactiveAdvisory } from './LAANCAdvisory.tsx';

export const ControlledAirspaceAdvisory = (props: IControlledAirspaceAdvisoryProperties  & { mission: MissionFeatureCollection }) => {
    return (
        <LAANCInactiveAdvisory mission={props.mission} airspaceNames={[props.NAME]} offersFC={false} />
    );
};
